import * as React from "react"
import ReactDOM from "react-dom"
import { Map } from "mapbox-gl"
import Where2GoControls from "./Where2GoControls"
import { IWhere2goState } from "../../redux/actions/where2go"
import * as s from "./style.scss"


/**
 * Creates new control which can be used on the Map.
 * Groups all Control element into on singular control
 */
class BestWeatherControls {
    private map: Map
    private container: HTMLElement
    private formatMessage: any
    initialValues: IWhere2goState
    onChange: (values: object) => void

    constructor(formatMessage, initialValues: IWhere2goState, onChange: (values: object) => void) {
        this.formatMessage = formatMessage
        this.initialValues = initialValues
        this.onChange = onChange
    }

    public onAdd(map: Map) {
        this.map = map
        this.container = document.createElement("div")
        this.container.className = s.customControl
        ReactDOM.render((
            <Where2GoControls
                formatMessage={this.formatMessage}
                initialValues={this.initialValues}
                onChange={this.onChange}
            />
        ), this.container)
        return this.container
    }

    public onRemove() {
        this.container.removeChild(this.container)
        this.map = undefined
    }
}

export default BestWeatherControls